import { types } from "../../types/types";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import { handleErrorApi } from "../../helpers/randoms";
import ContratacionesService from "../../services/ContratacionesService";

export const obtenerInclusionesExclusiones = () => {
  return async (dispatch, getState) => {
    try {
      const { dataContrato } = getState().contrataciones;
      let response = null;

      response = await ContratacionesService.traerInclusionesExclusiones(dataContrato.idEfectorFacturacion);
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.contratacionesSetearInclusionesExclusiones,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(startAlerta(error?.errores?.mensaje || error?.errores, "warning", "", true))
      // handleErrorApi(dispatch, error, "Error al obtener las inclusiones y exclusiones", "Ha ocurrido un error. Intente nuevamente")
    }
  };
};

export const guardarInclusionesExclusiones = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { dataContrato } = getState().contrataciones;
      data.idEfectorFacturacion = dataContrato.idEfectorFacturacion;

      let response = await ContratacionesService.guardarInclusionesExclusiones(dataContrato.idEfectorFacturacion, data)
      const body = await response.json();
      if (response.ok) {
        dispatch(obtenerInclusionesExclusiones())
        dispatch(finishSpinner())
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(dispatch, error, "Error al guardar las inclusiones/exclusiones", "Ha ocurrido un error. Intente nuevamente")
    }
  };
};
